import React, {useEffect, useState} from 'react';

const ClientDetails = ({
                           lat = '',
                           long = '',
                           handleInput,
                           locationPinCode,
                           accountDetailsByIdData,
                           inputList,
                           isView=false
                       }) => {


    const [city, setCity] = useState('');
    const [state, setState] = useState('');
    const [isLoading, setIsLoading] = useState(false)
    const [pincodeValue, setPincodeValue] = useState('')

    const handlePincode = async (pincode) => {
        if (pincode === '') return false
        handleInput(pincode, 'client_pincode')
        setIsLoading(true)
        setPincodeValue(pincode)
        let res = await locationPinCode(pincode)
        setIsLoading(false)
        setCity(res[0]?.city_name !== undefined ? res[0]?.city_name : '')
        setState(res[0]?.state_name !== undefined ? res[0]?.state_name : '')
        handleInput(res[0]?.geo_city_id, 'client_city_id')
        handleInput(res[0]?.geo_state_id, 'client_state_id')
    }


    useEffect(() => {
        if (accountDetailsByIdData !== [] && accountDetailsByIdData?.account_type_id !== undefined) {
            handleInput(accountDetailsByIdData?.region, 'region')
            if(accountDetailsByIdData?.client_pincode !== undefined && accountDetailsByIdData?.client_pincode !== null){
                handlePincode(accountDetailsByIdData?.client_pincode)
            }

            handleInput(accountDetailsByIdData?.client_lat, 'client_lat')
            handleInput(accountDetailsByIdData?.client_long, 'client_long')
            handleInput(accountDetailsByIdData?.client_address_1, 'client_address_1')
            handleInput(accountDetailsByIdData?.client_address_2, 'client_address_2')

        }

    }, [accountDetailsByIdData])

    return (
        <>
            <div className="col-sm-6 float-field mt-1">
                <input type="number"
                       className="form-control form-control-user"
                       placeholder=" "
                       onChange={(e) => {
                           handlePincode(e.target.value)
                       }}
                       required
                       value={pincodeValue}
                       disabled={isView}
                />
                <label className="large-label float-lb">
                    Pincode <i className="bi bi-asterisk astrick-icon"></i>
                </label>
            </div>
            <div className="col-sm-6 float-field mt-1">
                <input type="text"
                       className="form-control form-control-user"
                       placeholder=" "
                       onChange={(e) => {
                           handleInput(city, 'client_city_id')
                       }}
                       disabled
                       value={city}
                       required
                />
                <label className="large-label float-lb">
                    City <i className="bi bi-asterisk astrick-icon"></i>
                </label>
            </div>
            <div className="col-sm-6 float-field mt-1">
                <input type="text"
                       className="form-control form-control-user"
                       placeholder=" "
                       onChange={(e) => {
                           handleInput(state, 'client_state_id')
                       }}
                       disabled
                       value={state}
                       required
                />
                <label className="large-label float-lb">
                    State <i className="bi bi-asterisk astrick-icon"></i>
                </label>
            </div>
            <div className="col-sm-6 float-field mt-1">
                <input type="text"
                       className="form-control form-control-user"
                       placeholder=" "
                       onChange={(e) => {
                           handleInput(lat, 'client_lat')
                       }}
                       disabled
                       value={lat}
                       required
                />
                <label className="large-label float-lb">
                    Latitude <i className="bi bi-asterisk astrick-icon"></i>
                </label>
            </div>
            <div className="col-sm-6 float-field mt-1">
                <input type="text"
                       className="form-control form-control-user"
                       placeholder=" "
                       onChange={(e) => {
                           handleInput(long, 'client_long')
                       }}
                       disabled
                       value={long}
                       required
                />
                <label className="large-label float-lb">
                    Longitude <i className="bi bi-asterisk astrick-icon"></i>
                </label>
            </div>
            <div className="col-sm-6 float-field mt-1">
                <input type="text"
                       className="form-control form-control-user"
                       placeholder=" "
                       onChange={(e) => {
                           handleInput(e.target.value, 'client_address_1')
                       }}
                       required
                       value={inputList[0]?.client_address_1}
                       disabled={isView}
                />
                <label className="large-label float-lb">
                    Address <i className="bi bi-asterisk astrick-icon"></i>
                </label>
            </div>
            {/*<div className="col-sm-6 float-field mt-1">*/}
            {/*    <input type="text"*/}
            {/*           className="form-control form-control-user"*/}
            {/*           placeholder=" "*/}
            {/*           onChange={(e) => {*/}
            {/*               handleInput(e.target.value, 'client_address_2')*/}
            {/*           }}*/}
            {/*           value={inputList[0]?.client_address_2}*/}
            {/*    />*/}
            {/*    <label className="large-label float-lb">*/}
            {/*        Address of site 2*/}
            {/*    </label>*/}
            {/*</div>*/}
        </>
    );
}
export default ClientDetails;